export default __webpack_public_path__ + "static/media/colgate-logo.68cc7d42.png";